import { MD_LANGUAGE_SET } from "../const";

export type ReduxAction = {
  type: string;
  payload: string;
};

export const setMDLanguage = (language: string): ReduxAction => {
  localStorage.setItem('language', language);
  
  return {
    type: MD_LANGUAGE_SET,
    payload: language,
  }
};
